import React from "react";
import { observer } from "mobx-react";
import { DateTime } from "luxon";

import classNames from "classnames";
import { BetOffer } from "@models";
import MyBetsViewStore from "@state/stores/my-bets/MyBetsViewStore";

export default observer(function BetOfferEventTime(props: {
	bet: BetOffer;
	myBetsViewStore: MyBetsViewStore;
	isInDetails?: boolean;
}) {
	function checkIfIsMulti() {
		if (props.bet.isMulti) {
			return { time: "", cssClass: "" };
		}

		if (
			props.myBetsViewStore?.activeEventsStore.eventsMap.has(
				props.bet.eventId
			)
		) {
			if (
				props.myBetsViewStore.activeEventsStore.eventsMap.get(
					props.bet.eventId
				)?.matchTime?.displayTime
			) {
				return {
					time: props.myBetsViewStore.activeEventsStore.eventsMap.get(
						props.bet.eventId
					)?.matchTime?.displayTime,
					cssClass: "u-color--sent--danger",
				};
			}

			return {
				time: DateTime.fromISO(
					props.bet.sportData.eventStartTime
				).toFormat("dd.MM. HH:mm"),
				cssClass: "u-color--text--tertiary",
			};
		}
		return {
			time: DateTime.fromISO(props.bet.sportData.eventStartTime).toFormat(
				"dd.MM. HH:mm"
			),
			cssClass: "u-color--text--tertiary",
		};
	}

	const data = checkIfIsMulti();

	return (
		<div
			className={classNames("widget--bets__time", data?.cssClass, {
				"u-mar--bottom--reset": props.isInDetails,
			})}
			title={"Match time"}
		>
			{data?.time}
		</div>
	);
});
